/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useNavigate, useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { Box, Button, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton, MenuItem, Select, Switch, TextField, Typography, useTheme } from '@mui/material';
import QrCodeIcon from '@mui/icons-material/QrCode';

import { IInstrumento } from '../../services/api/dams/DamServices';
import { InstrumentsServices } from '../../services/api/instruments/InstrumentosServices';
import { Loadin, Svg, VColorPiker, VSelecInstruments } from '../../components/shared';
import { LayoutBase } from '../../layouts';
import { Base, Inclinometro, Indicador, Piezomentro, Pluviometrico, Re, Regua, ToolsDetails, Topografico, Vazao } from '../../components/custom';
import { useAuthContext } from '../../context';
import { VAutoCompletEmployer } from '../../components/shared/VAutoCompletEmployer';
import { CustomAlert } from '../../components/shared/VAlert';
import { IIcon, IconServices } from '../../services/api/icons/IconsServices';
import { Colorize } from '@mui/icons-material';
import ReactInputMask from 'react-input-mask';
import QRCode from 'qrcode';
import { jsPDF } from 'jspdf';
import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { AppSnackbarAlert } from '../../components/shared/AppSnackbarAlert';


export const Instruments = () => {

    const url = useParams();
    const [isLoading, setIsLonding] = useState(true);
    const navigate = useNavigate();
    const theme = useTheme();
    const { userData } = useAuthContext();
    const companyUuid = userData.id_empresa;
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });

    const [iconList, setIconList] = useState<IIcon[]>([]);
    const [loadinIcons, setLoadinIcons] = useState(true);
    const [colorIcon, setColorIcon] = useState('');
    const [dialogColor, setDialogColor] = useState(false);
    const [selectedIcon, setSelectedIcon] = useState('');
    const [icon, setIcon] = useState(undefined);

    const [showAlertState, setShowAlertState] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>('');
    const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'warning' | 'info'>('success');

    const handleCloseAlert = () => {
        setShowAlertState(false);
    };

    useEffect(() => {
        iconData();
        fetchData();
    }, [url.uuid]);

    useEffect(() => {
        makeIcon();
    }, [colorIcon]);

    const iconData = () => {
        IconServices.get()
            .then((result) => {
                if (result instanceof Error) {
                    console.log(result.message);
                } else {
                    setIconList(result);
                    setLoadinIcons(false);
                }
            });
    };

    const fetchData = () => {
        if (url.uuid) {
            if (url.uuid == 'new') {
                setIsLonding(false);
            } else {
                InstrumentsServices.getById(url.uuid)
                    .then((response) => {
                        if (response instanceof Error) {
                            console.log(response.message);
                        } else {
                            setData(response);
                            if (response.cor_icone) {
                                setColorIcon(response.cor_icone);
                            }
                            if (response.id_icone) {
                                setSelectedIcon(response.id_icone);
                            }
                            setIsLonding(false);
                        }
                    });
            }
        }
    };

    const handleColorDialog = async () => {
        const value = !dialogColor;
        setDialogColor(value);
    };

    const handleColorChange = (newColor: string) => {
        setColorIcon(newColor);
        setData(prevData => ({
            ...prevData,
            cor_icone: newColor
        }));
    };

    const handleIconChange = (uuid: string, icon: any) => {
        setSelectedIcon(uuid);
        setIcon(icon.icone);
        setData(prevData => ({
            ...prevData,
            id_icone: uuid
        }));
    };

    const makeIcon = () => {
        if (colorIcon != '' && selectedIcon != null) {
            // const color = colorIcon;
            // const icon = selectedIcon;
        }
    };

    const [data, setData] = useState<IInstrumento>({
        desabilitado: false,
        diametro_tubo: null,
        elevacao: null,
        elevacao_boca: null,
        elevacao_fundo: null,
        elevacao_terreno: null,
        formula_leitura: null,
        freq_monit: null,
        freq_monit_medida: null,
        id_icone: null,
        cor_icone: null,
        inclinacao: null,
        limite_faixa_amarela: null,
        limite_faixa_amarela_y: null,
        limite_faixa_amarela_z: null,
        limite_faixa_laranja: null,
        limite_faixa_laranja_y: null,
        limite_faixa_laranja_z: null,
        limite_faixa_verde: null,
        limite_faixa_verde_y: null,
        limite_faixa_verde_z: null,
        limite_faixa_vermelha: null,
        limite_faixa_vermelha_y: null,
        limite_faixa_vermelha_z: null,
        motivo_desabilitado: null,
        nome: '',
        projecao: null,
        responsavel_id: '',
        status: null,
        tamanho_icone: null,
        tipo: null,
        tipo_instrumento: '',
        unidade_medida: null,
        utm_ew: null,
        utm_ns: null,
    });

    const [validations, setValidations] = useState<{ [key: string]: boolean }>({
        nome: false,
        utm_ew: false,
        utm_ns: false,
        projecao: false,
        tipo_instrumento: false,
        responsavel_id: false,
        id_icone: false,
    });

    const [validationsPiezometro, setValidationsPiezometro] = useState<{ [key: string]: boolean }>({
        unidade_medida: false,
        elevacao_fundo: false,
        elevacao_terreno: false,
        elevacao_boca: false,
        diametro_tubo: false,
        freq_monit: false,
        limite_faixa_verde: false,
        limite_faixa_amarela: false,
        limite_faixa_laranja: false,
        limite_faixa_vermelha: false
    });

    const [validationsIndicador, setValidationsIndicador] = useState<{ [key: string]: boolean }>({
        unidade_medida: false,
        elevacao_fundo: false,
        elevacao_terreno: false,
        elevacao_boca: false,
        diametro_tubo: false,
        freq_monit: false,
        limite_faixa_verde: false,
        limite_faixa_amarela: false,
        limite_faixa_laranja: false,
        limite_faixa_vermelha: false
    });

    const [validationsVazao, setValidationsVazao] = useState<{ [key: string]: boolean }>({
        elevacao: false,
        tipo: false,
        unidade_medida: false,
        freq_monit_medida: false,
        freq_monit: false,
    });

    const [validationsRegua, setValidationsRegua] = useState<{ [key: string]: boolean }>({
        elevacao: false,
        unidade_medida: false,
        freq_monit_medida: false,
        freq_monit: false,
    });

    const [validationsTopografico, setValidationsTopografico] = useState<{ [key: string]: boolean }>({
        elevacao: false,
        unidade_medida: false,
        freq_monit_medida: false,
        freq_monit: false,
        tipo: false,
        limite_faixa_verde: false,
        limite_faixa_verde_x: false,
        limite_faixa_verde_y: false,
        limite_faixa_amarelo: false,
        limite_faixa_amarelo_x: false,
        limite_faixa_amarelo_y: false,
        limite_faixa_laranja: false,
        limite_faixa_laranja_x: false,
        limite_faixa_laranja_y: false,
        limite_faixa_vermelho: false,
        limite_faixa_vermelho_x: false,
        limite_faixa_vermelho_y: false,
    });

    const [validationsRe, setValidationsRe] = useState<{ [key: string]: boolean }>({
        elevacao: false,
        unidade_medida: false,
        tipo: false
    });

    const [validationsBase, setValidationsBase] = useState<{ [key: string]: boolean }>({
        elevacao: false,
        unidade_medida: false,
        tipo: false
    });

    const [validationsInclinometro, setValidationsInclinometro] = useState<{ [key: string]: boolean }>({
        elevacao: false,
        unidade_medida: false,
        freq_monit_medida: false,
        freq_monit: false,
        inclinacao: false
    });

    const [validationsPluviometrico, setValidationsPluviometrico] = useState<{ [key: string]: boolean }>({
        elevacao: false,
        unidade_medida: false,
        freq_monit_medida: false,
        freq_monit: false,
        tipo: false
    });

    useEffect(() => {
        if (userData.nivel == 'user') {
            if (userData.uuid) {
                data.responsavel_id = userData.uuid;
            }
        }
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value, type, checked, name } = e.target;

        if (name === 'utm_ew' || name === 'utm_ns') {
            setData(prevData => ({
                ...prevData,
                [name]: value
            }));
        } else {
            const convertedValue = type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) : value;

            setData(prevData => ({
                ...prevData,
                [id]: convertedValue
            }));
        }
    };

    async function validateData(data: IInstrumento) {
        const cleanedData = { ...data };
        if (typeof cleanedData.utm_ew === 'string') {
            cleanedData.utm_ew = parseFloat((cleanedData.utm_ew as string).replace(/[^\d.-]/g, ''));
        }
        if (typeof cleanedData.utm_ns === 'string') {
            cleanedData.utm_ns = parseFloat((cleanedData.utm_ns as string).replace(/[^\d.-]/g, ''));
        }

        const newValidations = {
            nome: !cleanedData.nome,
            utm_ew: !cleanedData.utm_ew || isNaN(cleanedData.utm_ew),
            utm_ns: !cleanedData.utm_ns || isNaN(cleanedData.utm_ns),
            tipo_instrumento: !cleanedData.tipo_instrumento,
            responsavel_id: !cleanedData.responsavel_id,
            id_icone: !cleanedData.id_icone
        };
        setValidations(newValidations);
        const isAnyInvalid = Object.values(newValidations).some(value => value);

        if (!isAnyInvalid) {
            if (cleanedData.tipo_instrumento === 'piezometro') {
                const newValidationsPiezometro = {
                    unidade_medida: !cleanedData.unidade_medida,
                    elevacao_fundo: !cleanedData.elevacao_fundo,
                    elevacao_terreno: !cleanedData.elevacao_terreno,
                    elevacao_boca: !cleanedData.elevacao_boca,
                    diametro_tubo: !cleanedData.diametro_tubo,
                    freq_monit: !cleanedData.freq_monit,
                };

                setValidationsPiezometro(newValidationsPiezometro);
                const isValid = Object.values(newValidationsPiezometro).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 'indicador') {
                const newValidationsIndicador = {
                    unidade_medida: !cleanedData.unidade_medida,
                    elevacao_fundo: !cleanedData.elevacao_fundo,
                    elevacao_terreno: !cleanedData.elevacao_terreno,
                    elevacao_boca: !cleanedData.elevacao_boca,
                    diametro_tubo: !cleanedData.diametro_tubo,
                    freq_monit: !cleanedData.freq_monit,
                };

                setValidationsIndicador(newValidationsIndicador);
                const isValid = Object.values(newValidationsIndicador).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 'vazao') {
                const newValidationsVazao = {
                    elevacao: !cleanedData.elevacao,
                    tipo: !cleanedData.tipo,
                    unidade_medida: !cleanedData.unidade_medida,
                    freq_monit: !cleanedData.freq_monit
                };

                setValidationsVazao(newValidationsVazao);
                const isValid = Object.values(newValidationsVazao).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 'regua') {
                const newValidationsRegua = {
                    elevacao: !cleanedData.elevacao,
                    unidade_medida: !cleanedData.unidade_medida,
                    freq_monit: !cleanedData.freq_monit
                };

                setValidationsRegua(newValidationsRegua);
                const isValid = Object.values(newValidationsRegua).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 'marco') {
                const newValidationsMarco = {
                    elevacao: !cleanedData.elevacao,
                    unidade_medida: !cleanedData.unidade_medida,
                    freq_monit: !cleanedData.freq_monit,
                };

                setValidationsTopografico(newValidationsMarco);
                const isValid = Object.values(newValidationsMarco).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 're') {
                const newValidationsRe = {
                    elevacao: !cleanedData.elevacao,
                    unidade_medida: !cleanedData.unidade_medida,
                    tipo: !cleanedData.tipo,
                };

                setValidationsRe(newValidationsRe);
                const isValid = Object.values(newValidationsRe).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 'base') {
                const newValidationsBase = {
                    elevacao: !cleanedData.elevacao,
                    unidade_medida: !cleanedData.unidade_medida,
                    tipo: !cleanedData.tipo,
                };

                setValidationsBase(newValidationsBase);
                const isValid = Object.values(newValidationsBase).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 'inclinometro') {
                const newValidationsInclinometro = {
                    elevacao: !cleanedData.elevacao,
                    unidade_medida: !cleanedData.unidade_medida,
                    freq_monit: !cleanedData.freq_monit,
                    inclinacao: !cleanedData.inclinacao
                };

                setValidationsInclinometro(newValidationsInclinometro);
                const isValid = Object.values(newValidationsInclinometro).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            } else if (cleanedData.tipo_instrumento === 'pluviometro') {
                const newValidationsPluviometrico = {
                    elevacao: !cleanedData.elevacao,
                    unidade_medida: !cleanedData.unidade_medida,
                    freq_monit: !cleanedData.freq_monit,
                    tipo: !cleanedData.tipo
                };

                setValidationsPluviometrico(newValidationsPluviometrico);
                const isValid = Object.values(newValidationsPluviometrico).some(value => value);
                if (!isAnyInvalid && !isValid) {
                    return !isAnyInvalid;
                } else {
                    return isAnyInvalid;
                }
            }
        }
        return !isAnyInvalid;
    }

    function handleTipoIntrument(tipo: string) {
        setData(prevData => ({
            ...prevData,
            tipo_instrumento: tipo,
        }));
    }

    function handleFrenquencyChange(frequncy: string) {
        setData(prevData => ({
            ...prevData,
            freq_monit_medida: frequncy,
        }));
    }

    function handleUserChange(user: string) {
        setData(prevData => ({
            ...prevData,
            responsavel_id: user
        }));
    }

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setData({ ...data, desabilitado: event.target.checked });
    };


    async function handleSave() {
        if (url) {
            if (url.uuid) {
                const dataToSave = { ...data };

                if (typeof dataToSave.utm_ew === 'string') {
                    dataToSave.utm_ew = parseFloat((dataToSave.utm_ew as string).replace(/[^\d.-]/g, ''));
                }
                if (typeof dataToSave.utm_ns === 'string') {
                    dataToSave.utm_ns = parseFloat((dataToSave.utm_ns as string).replace(/[^\d.-]/g, ''));
                }

                const isValid = await validateData(dataToSave);

                if (isValid) {
                    if (url.uuid !== 'new') {
                        const response = await InstrumentsServices.upgrade(url.uuid, dataToSave);
                        if (response instanceof Error) {
                            setAlertInfo({ open: true, message: 'Não foi possível atualizar o instrumento! ' + response.message, severity: 'error' });
                        }
                        else {
                            setAlertInfo({ open: true, message: 'Instrumento atualizado com sucesso!', severity: 'success' });
                        }
                    } else {
                        if (url.dam) {
                            setValidations(prevState => ({
                                ...prevState,
                                id_empresa: true
                            }));

                            const response = await InstrumentsServices.create(url.dam, dataToSave);
                            if (response instanceof Error) {
                                setAlertInfo({ open: true, message: 'Não foi possível salvar o instrumento! ' + response.message, severity: 'error' });
                            } else {
                                setAlertInfo({ open: true, message: 'Instrumento salvo com sucesso!', severity: 'success' });
                                setTimeout(() => {
                                    navigate(`/information_dam/${url.dam}/monitoring_instrumentation_plan`);
                                    fetchData();
                                }, 1500);
                            }
                        }
                    }
                }
            }
        }
    }

    function handleNew() {
        navigate(`/information_dam/${url.dam}/instrument/new`);
        window.location.reload();
    }

    async function handleQR() {
        setAlertMessage('');
        setAlertSeverity('error');
        setShowAlertState(false);
        try {
            const PRODUCTION_DOMAIN = 'https://hmlg.htisystem.com.br';

            const origin = Capacitor.isNativePlatform() ? PRODUCTION_DOMAIN : window.location.origin;

            const url_qr = `${origin}/information_dam/${url.dam}/instrument_reading/${url.uuid}/${data.tipo_instrumento}`;
            const qr_code = await QRCode.toDataURL(url_qr, { width: 400, margin: 2 });

            const doc = new jsPDF('p', 'mm', 'a4');
            const center = doc.internal.pageSize.getWidth() / 2;
            doc.addImage(qr_code, 'PNG', center - (60 / 2), 40, 60, 60);

            const fileName = data.nome ? `${data.nome}.pdf` : 'instrumento.pdf';

            if (Capacitor.isNativePlatform()) {

                const pdfData = doc.output('datauristring');
                const base64Content = pdfData.split(',')[1];

                await Filesystem.writeFile({
                    path: fileName,
                    data: base64Content,
                    directory: Directory.Documents,
                    recursive: true
                });

                setAlertMessage(`Arquivo "${fileName}" salvo em Documents!`);
                setAlertSeverity('success');
                setShowAlertState(true);

            } else {
                doc.save(fileName);
            }

        } catch (error) {
            console.error('Erro ao gerar ou salvar PDF:', error);
            setAlertMessage('Erro ao salvar documento!');
            setAlertSeverity('error');
            setShowAlertState(true);
        }
    }


    return (
        <LayoutBase
            title={url.uuid == 'new' ? 'Novo instrumento' : data.nome}
            tollBar={
                <ToolsDetails
                    onClickSave={handleSave}
                    onClickNew={handleNew}
                    showDeletButton={false}
                />
            }
        >
            {isLoading ?
                (<Loadin />) : (
                    <Box width={'100%'}>
                        <Grid container direction={'column'} padding={2} spacing={2}>
                            <Grid container item direction={'row'} spacing={2}>
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant='h5'>Informações Gerais</Typography>
                                        {url.uuid !== 'new' ?
                                            <Button variant='contained' onClick={handleQR} startIcon={<QrCodeIcon />} />
                                            : null}
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: true }}
                                        label='Nome' id='nome'
                                        fullWidth value={data.nome || ''}
                                        onChange={handleChange}
                                        error={validations.nome}
                                        required />
                                </Grid>
                                <Grid item xs={6}>
                                    <VSelecInstruments tipoInicial={data.tipo_instrumento}
                                        onTipoChange={(novoTipo) => handleTipoIntrument(novoTipo)}
                                        error={validations.tipo_instrumento}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField InputLabelProps={{ shrink: true }}
                                        label='Projeção' id='projecao'
                                        fullWidth value={data.projecao || ''}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                {url.uuid == 'new' && companyUuid ?
                                    <Grid item xs={6}>
                                        <VAutoCompletEmployer uuidCompany={companyUuid}
                                            onUserChange={(user) => handleUserChange(user)}
                                            error={validations.responsavel_id}
                                            required />
                                    </Grid> : null
                                }
                                <Grid item xs={12}>
                                    <Typography variant='h5'>Icone</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={10}>
                                    <Box>
                                        {loadinIcons == false ? (
                                            <FormControl fullWidth>
                                                <Select
                                                    fullWidth
                                                    value={selectedIcon}
                                                    onChange={(event) => handleIconChange(event.target.value as string, iconList.find(icon => icon.uuid === event.target.value))}
                                                    sx={{ borderColor: theme.palette.primary.contrastText }}
                                                >
                                                    {iconList.map(icon => (
                                                        <MenuItem key={icon.uuid} value={icon.uuid} sx={{ borderColor: theme.palette.primary.contrastText }}>
                                                            <Box display="flex" alignItems="center">
                                                                <Svg svgContent={icon.icone} width={20} height={20} fill={colorIcon} />
                                                                <Typography ml={1}>{icon.nome}</Typography>
                                                            </Box>
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        ) : (
                                            <Loadin />
                                        )}
                                    </Box>
                                </Grid>
                                <Grid item xs={2} alignContent={'center'} justifyItems={'center'} display={'flex'}>
                                    {selectedIcon != '' ? (
                                        <IconButton onClick={handleColorDialog}><Colorize sx={{ color: theme.palette.primary.contrastText }} /></IconButton>
                                    ) : (<></>)}
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant='h5'>Localização</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={6}>
                                    <ReactInputMask
                                        mask={'9999999.99'}
                                        value={data.utm_ns !== null && data.utm_ns !== undefined ? String(data.utm_ns) : ''}
                                        name='utm_ns'
                                        onChange={handleChange}
                                    >
                                        {() =>
                                            <TextField
                                                label='UTM NS'
                                                type='text'
                                                fullWidth
                                                name='utm_ns'
                                                InputLabelProps={{ shrink: true }}
                                                error={validations.utm_ns}
                                                helperText={validations.utm_ns ? 'Campo obrigatório' : ''}
                                                required
                                            />
                                        }
                                    </ReactInputMask>
                                </Grid>
                                <Grid item xs={6}>
                                    <ReactInputMask
                                        mask={'999999.99'}
                                        value={data.utm_ew !== null && data.utm_ew !== undefined ? String(data.utm_ew) : ''}
                                        name='utm_ew'
                                        onChange={handleChange}
                                    >
                                        {() =>
                                            <TextField
                                                label='UTM EW'
                                                type='text'
                                                fullWidth
                                                name='utm_ew'
                                                InputLabelProps={{ shrink: true }}
                                                error={validations.utm_ew}
                                                helperText={validations.utm_ew ? 'Campo obrigatório' : ''}
                                                required
                                            />
                                        }
                                    </ReactInputMask>
                                </Grid>

                            </Grid>
                        </Grid>
                        {data.tipo_instrumento === 'piezometro' && (
                            <Piezomentro
                                data={data}
                                handleChange={handleChange}
                                validations={validationsPiezometro}
                                handleFrenquencyChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            />
                        )}
                        {data.tipo_instrumento === 'indicador' && (
                            <Indicador
                                data={data}
                                handleChange={handleChange}
                                validations={validationsIndicador}
                                handleFrenquencyChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            />
                        )}
                        {data.tipo_instrumento === 'vazao' && (
                            <Vazao
                                data={data}
                                handleChange={handleChange}
                                validations={validationsVazao}
                                handleFrenquencyChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            />
                        )}
                        {data.tipo_instrumento === 'regua' && (
                            <Regua
                                data={data}
                                handleChange={handleChange}
                                validations={validationsRegua}
                                handleFrenquencyChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            />
                        )}
                        {data.tipo_instrumento === 're' && (
                            <Re
                                data={data}
                                handleChange={handleChange}
                                validations={validationsRe}
                            />
                        )}
                        {data.tipo_instrumento === 'base' && (
                            <Base
                                data={data}
                                handleChange={handleChange}
                                validations={validationsBase}
                            />
                        )}
                        {data.tipo_instrumento === 'inclinometro' && (
                            <Inclinometro
                                data={data}
                                handleChange={handleChange}
                                validations={validationsInclinometro}
                                handleFrenquencyChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            />
                        )}
                        {data.tipo_instrumento === 'pluviometro' && (
                            <Pluviometrico
                                data={data}
                                handleChange={handleChange}
                                validations={validationsPluviometrico}
                                handleFrenquencyChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            />
                        )}
                        {data.tipo_instrumento === 'marco' && (
                            <Topografico
                                data={data}
                                handleChange={handleChange}
                                validations={validationsTopografico}
                                handleFrenquencyChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            />
                        )}
                        <Grid container item direction={'row'} spacing={2} padding={2}>
                            <Grid item xs={12}>
                                <Typography variant='h5'>Desativado</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={6} justifyContent='center' alignContent='center'>
                                <Box display='flex' justifyContent='center'>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Switch checked={data.desabilitado ? data.desabilitado : false} onChange={handleSwitchChange} />}
                                            label='Desabilitado'
                                        />
                                    </FormGroup>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField label='Motivo' id='motivo_desabilitado' fullWidth value={data.motivo_desabilitado || ''}
                                    onChange={handleChange} multiline rows={3} />
                            </Grid>
                        </Grid>
                    </Box>
                )}
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                />
            }
            <VColorPiker
                isOpen={dialogColor}
                onClose={handleColorDialog}
                onColorChange={handleColorChange}
                svg={icon}
            />
            {showAlertState && (
                <AppSnackbarAlert
                    message={alertMessage}
                    severity={alertSeverity}
                    open={showAlertState}
                    onClose={handleCloseAlert}
                />
            )}
        </LayoutBase>
    );
};